/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    RouteLocationInput,
    RouteLocationInputFromJSON,
    RouteLocationInputFromJSONTyped,
    RouteLocationInputToJSON,
} from './';

/**
 * 
 * @export
 * @interface CriteriaForRouteInput
 */
export interface CriteriaForRouteInput {
    /**
     * 
     * @type {RouteLocationInput}
     * @memberof CriteriaForRouteInput
     */
    to?: RouteLocationInput;
    /**
     * 
     * @type {RouteLocationInput}
     * @memberof CriteriaForRouteInput
     */
    from?: RouteLocationInput;
    /**
     * 
     * @type {boolean}
     * @memberof CriteriaForRouteInput
     */
    exclude?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CriteriaForRouteInput
     */
    isOutbound?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CriteriaForRouteInput
     */
    match?: boolean;
}

export function CriteriaForRouteInputFromJSON(json: any): CriteriaForRouteInput {
    return CriteriaForRouteInputFromJSONTyped(json, false);
}

export function CriteriaForRouteInputFromJSONTyped(json: any, ignoreDiscriminator: boolean): CriteriaForRouteInput {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'to': !exists(json, 'to') ? undefined : RouteLocationInputFromJSON(json['to']),
        'from': !exists(json, 'from') ? undefined : RouteLocationInputFromJSON(json['from']),
        'exclude': !exists(json, 'exclude') ? undefined : json['exclude'],
        'isOutbound': !exists(json, 'isOutbound') ? undefined : json['isOutbound'],
        'match': !exists(json, 'match') ? undefined : json['match'],
    };
}

export function CriteriaForRouteInputToJSON(value?: CriteriaForRouteInput | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'to': RouteLocationInputToJSON(value.to),
        'from': RouteLocationInputToJSON(value.from),
        'exclude': value.exclude,
        'isOutbound': value.isOutbound,
        'match': value.match,
    };
}


